import {NgModule} from '@angular/core';
import {OrdersRegroupDialogComponent} from "./orders-regroup-dialog.component";
import {OoaSolutionPagerComponent} from "./ooa-solution-pager.component";
import {CommonModule} from "@angular/common";
import {DevExtremeModule} from "../devextreme.module";
import {EtsCommonModule} from "../common-services/common.module";
import {GenericConfirmationDialogModule} from "../generic-confirmation-dialog/generic-confirmation-dialog.module";


@NgModule({
    imports: [
        CommonModule,
        EtsCommonModule,
        DevExtremeModule,
        GenericConfirmationDialogModule
    ],
    exports: [OrdersRegroupDialogComponent, OoaSolutionPagerComponent],
    declarations: [OrdersRegroupDialogComponent, OoaSolutionPagerComponent],
    providers: [],
})
export class OrdersRegroupModule {
}
